import { useMemo } from 'react';
import useUserTheme from './useUserTheme';
import {
  createUserPageSx,
  createUserTableFilters,
  createUserTableOverrides,
} from '../styles/userLayout';

export default function useUserSx() {
  const tokens = useUserTheme();
  return useMemo(() => {
    const tableStyles = createUserTableOverrides(tokens);
    return {
      ...createUserPageSx(tokens),
      ...tableStyles,
      tableFilters: createUserTableFilters(tokens),
    };
  }, [tokens]);
}
